import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";

export default function AdminActivity() {
  const { data } = useQuery({ queryKey: ["activity"], queryFn: () => api.get("/admin/activity").then((r) => r.data) });
  const items = data?.items || [];
  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.24em] text-amber-600">Audit</div>
        <h1 className="font-display text-3xl text-slate-950 mt-1">Activity Logs</h1>
      </div>
      <Card className="border border-slate-200"><CardContent className="p-0">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="text-left px-4 py-3 font-medium text-slate-600">When</th>
              <th className="text-left px-4 py-3 font-medium text-slate-600">Action</th>
              <th className="text-left px-4 py-3 font-medium text-slate-600">Resource</th>
              <th className="text-left px-4 py-3 font-medium text-slate-600">Ref ID</th>
            </tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-b border-slate-100">
                <td className="px-4 py-3 text-slate-500 text-xs">{new Date(a.at).toLocaleString()}</td>
                <td className="px-4 py-3 text-slate-800 font-medium">{a.action}</td>
                <td className="px-4 py-3">{a.resource}</td>
                <td className="px-4 py-3 font-mono text-xs">{a.resource_id || "—"}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={99} className="text-center py-16 text-slate-400">No activity yet.</td></tr>}
          </tbody>
        </table>
      </CardContent></Card>
    </div>
  );
}
